import z from "zod";

/**
 * InspecaoObraSchema
 */

export const InspecaoObraSchema = z.object({
  data: z.coerce.date({ required_error: "Este campo deve ser preenchido!" }),
  campo1: z.string().nullable().default(null),
  campo2: z.string().nullable().default(null),
  campo3: z.string().nullable().default(null),
  campo4: z.string().nullable().default(null),
});

/**
 * InspecaoObraForm
 */

export type InspecaoObraForm = z.infer<typeof InspecaoObraSchema>;